export { default as ScanRewards } from './scan-rewards';
